import React from 'react';

/**
 * CariCard — seçili cariyi tek bakışta gösteren özet kart.
 * - Avatar (initials), ünvan/code, VKN+vergi dairesi, telefon, adres
 * - "Değiştir" butonu → onChange callback
 * - Cari yoksa → "Müşteri Seç" placeholder kart
 * - Potansiyel cari → "Potansiyel" pill
 */
function initials(name) {
  if (!name) return '?';
  return name
    .replace(/\bLtd\.?|\bŞti\.?|\bA\.Ş\.?|\bSan\.?|\bTic\.?|\bİnş\.?|\bİml\.?/gi, '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';
}

const ICON = {
  user: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  pickPlus: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
};

export default function CariCard({
  cari = null,
  addresses = [],
  isProspect = false,
  disabled = false,
  onPick,           // boş kart tıklanınca veya Değiştir
  onQuickAddProspect, // opsiyonel — quote/teklif modu için
  allowQuickAddProspect = false,
  label = 'Müşteri',
  required = false,
}) {
  if (!cari) {
    return (
      <div className="caricard-empty" onClick={!disabled && onPick ? onPick : undefined}>
        <div className="caricard-empty-icon">{ICON.user}</div>
        <div className="caricard-empty-body">
          <div className="caricard-empty-title">
            {label} seç{required ? ' *' : ''}
          </div>
          <div className="caricard-empty-hint">Ünvan, VKN, telefon veya kod ile arayabilirsin</div>
        </div>
        <div className="caricard-empty-cta">
          {ICON.pickPlus} Seç
        </div>
      </div>
    );
  }

  const isCompany = cari.identity_type !== 'individual';
  const taxLine = (() => {
    const parts = [];
    if (isCompany) {
      if (cari.tax_number) parts.push(<><b key="tn">VKN {cari.tax_number}</b></>);
      if (cari.tax_office)  parts.push(cari.tax_office);
    } else {
      if (cari.id_number)  parts.push(<><b key="tc">TC {cari.id_number}</b></>);
    }
    const phone = cari.phone || cari.mobile;
    if (phone) parts.push(phone);
    return parts;
  })();

  const primaryAddr = (() => {
    if (!addresses || !addresses.length) return cari.address || '';
    const def = addresses.find(a => a.is_default) || addresses[0];
    const txt = def?.address || '';
    const city = def?.city ? ' / ' + def.city : '';
    return txt + city;
  })();

  return (
    <div className={`caricard ${isProspect ? 'is-prospect' : ''} ${disabled ? 'is-disabled' : ''}`}>
      <div className="caricard-av">{initials(cari.title || cari.name)}</div>
      <div className="caricard-info">
        <div className="caricard-name-row">
          <span className="caricard-name">
            {cari.title || cari.name}
            {cari.code ? <span className="caricard-code"> · {cari.code}</span> : null}
          </span>
          {isProspect && <span className="caricard-pill prospect">Potansiyel</span>}
          {cari.account_type === 'supplier' && <span className="caricard-pill supplier">Tedarikçi</span>}
        </div>
        {taxLine.length > 0 && (
          <div className="caricard-meta">
            {taxLine.map((p, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="dot">·</span>}
                {p}
              </React.Fragment>
            ))}
          </div>
        )}
        {primaryAddr && (
          <div className="caricard-addr">{primaryAddr}</div>
        )}
      </div>
      <div className="caricard-actions">
        {allowQuickAddProspect && onQuickAddProspect && !disabled && (
          <button type="button" className="caricard-btn" onClick={onQuickAddProspect} title="Yeni potansiyel cari ekle">
            + Potansiyel
          </button>
        )}
        {!disabled && onPick && (
          <button type="button" className="caricard-btn" onClick={onPick}>
            Değiştir
          </button>
        )}
      </div>
    </div>
  );
}
